import React from 'react';
import { Box, Typography, Stack, Divider } from '@mui/material';
import { ApplicationPaymentSummaryProps } from '../types';

const feeLabels = {
  additionalInspectionFee: 'Additional Inspection Fee',
  applicationFee: 'Application Fee',
  inspectionFee: 'Inspection Fee',
  taxRate: 'Tax Rate',
  treeReplacementFee: 'Tree Replacement Fee',
  buildingUCCFee: 'Building UCC Fee',
  electricalUCCFee: 'Electrical UCC Fee',
  mechanicalUCCFee: 'Mechanical UCC Fee',
  plumbingUCCFee: 'Plumbing UCC Fee',
  fireUCCFee: 'Fire Protection UCC Fee',
};

const ApplicationPaymentSummary: React.FC<ApplicationPaymentSummaryProps> = ({
  paymentSummary,
  totalTaxAmount,
  totalAmountPayable,
  totalAmountWithoutTax
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        alignItems: 'center',
        borderRadius: 2,
        boxShadow: 3,
        padding: { xs: 1.5, sm: 3 },
        mt: 4,
        border: '1px solid #e0e0e0',
        backgroundColor: '#ffffff'
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: 600 }}>
        Payment Summary
      </Typography>
      {paymentSummary?.fees && (
        <>
          {Object.entries(paymentSummary.fees).map(([key, value]) => (
            <React.Fragment key={key}>
              <Stack
                direction="row"
                justifyContent="space-between"
                sx={{ width: '100%', mt: 2 }}
                key={key}
              >
                <Typography>{feeLabels[key] || key}:</Typography>
                <Typography>${value.toFixed(2)}</Typography>
              </Stack>
              {<Divider sx={{ width: '100%', my: 1 }} />}
            </React.Fragment>
          ))}
          <Stack
            direction="row"
            justifyContent="space-between"
            
            sx={{ width: '100%', my: 1 }}
          >
            <Typography>Subtotal:</Typography>
            <Typography>${totalAmountWithoutTax.toFixed(2)}</Typography>
          </Stack>
          {paymentSummary?.taxRate && (
            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{ width: '100%', mb: 1 }}
            >
              <Typography>
                Processing Fee ({paymentSummary?.taxRate}%):
              </Typography>
              <Typography>${totalTaxAmount.toFixed(2)}</Typography>
            </Stack>
          )}
          <Divider sx={{ my: 1, width: '100%' }} />
          <Stack
            direction="row"
            justifyContent="space-between"
            sx={{ width: '100%' }}
          >
            <Typography sx={{ fontWeight: 600 }}>Total Amount:</Typography>
            <Typography sx={{ fontWeight: 600 }}>
              ${totalAmountPayable.toFixed(2)}
            </Typography>
          </Stack>
        </>
      )}
    </Box>
  );
};

export default ApplicationPaymentSummary;